// const { innerWidth: WINDOW_WIDTH, innerHeight: WINDOW_HEIGHT } = window;
// const guidelineBaseWidth = 1440;
// const guidelineBaseHeight = 900;

export const scaleWidth = (size, guidelineBaseWidth = 1440) =>
  (size / guidelineBaseWidth) * 100;
export const scaleHeight = (size, guidelineBaseHeight = 900) =>
  (size / guidelineBaseHeight) * 100;
